var React = require('react');

function LiveScore (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9 12C9 11.448 8.552 11 8 11C7.448 11 7 11.448 7 12C7 12.552 7.448 13 8 13C8.552 13 9 12.552 9 12Z","fill":"#181818","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.25 15.75H11.75C12.8675 15.75 13.75 14.8319 13.75 13.7273V2.27273C13.75 1.16813 12.8675 0.25 11.75 0.25H4.25C3.13248 0.25 2.25 1.16813 2.25 2.27273V13.7273C2.25 14.8319 3.13248 15.75 4.25 15.75ZM3.75 2.27273C3.75 1.97096 3.98627 1.75 4.25 1.75H11.75C12.0137 1.75 12.25 1.97096 12.25 2.27273V13.7273C12.25 14.029 12.0137 14.25 11.75 14.25H4.25C3.98627 14.25 3.75 14.029 3.75 13.7273V2.27273Z","fill":"#181818","key":1})]);
}

LiveScore.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LiveScore;

LiveScore.default = LiveScore;
